import {email} from 'redux-form-validators';

export default opts =>
  email({
    message: {id: 'validation.email_in_correct'},
    ...opts
  });



// WEBPACK FOOTER //
// ./validators/units/email.js